<template>
  <section>
    <div class="container">
      <div class="row">
        <div class="col">
          <div class="card green">
            <div class="card-content">
              <div class="icon">
                <img src="/imgs/icons/happy_realtime.png" alt="Completadas">
              </div>
              <div class="details">
                <h3>Completadas</h3>
                <h1>{{ completed }}</h1>
                <p>Chamadas Finalizadas</p>
              </div>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="card orange">
            <div class="card-content">
              <div class="icon">
                <img src="/imgs/icons/clock_realtime.png" alt="Em Espera">
              </div>
              <div class="details">
                <h3>Em Espera</h3>
                <h1>{{ wait }}</h1>
                <p>Chamadas em Espera</p>
              </div>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="card blue">
            <div class="card-content">
              <div class="icon">
                <img src="/imgs/icons/phone_realtime.png" alt="Ativas">
              </div>
              <div class="details">
                <h3>Ativas</h3>
                <h1>{{ active }}</h1>
                <p>Chamadas Ativas</p>
              </div>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="card red">
            <div class="card-content">
              <div class="icon">
                <img src="/imgs/icons/sad_realtime.png" alt="Abandonadas">
              </div>
              <div class="details">
                <h3>Abandonadas</h3>
                <h1>{{ abandon }}</h1>
                <p>Ligações Abandonadas</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-show="false">
      <div class="row">
        <card-realtime-dashboard v-for="op in filteredOperators" :key="op.id" :nome="op.nome" :id="op.id"
          :extension="op.extension_line" :status="userStatus" :connection="connection" :userQueues="op.queues">
        </card-realtime-dashboard>
      </div>
      <div class="col-md-5">
        <total-calls-dashboard :connection="connection" @totalWait="totalWait" />
      </div>
    </div>
  </section>
</template>

<script>
import axios from 'axios';
import io from 'socket.io-client';
import { getStatus } from "../realtime/status.js";
import totalCallsDashboard from '../realtime/TotalCallsDashboard.vue';
import cardRealtimeDashboard from '../realtime/CardRealtimeDashboard.vue';

export default {
  components: { cardRealtimeDashboard, totalCallsDashboard },
  data() {
    return {
      completed: 0,
      wait: 0,
      active: 0,
      connection: null,
      operators: [],
      queueSelect: '*',
      abandon: 0,
      userQueues: [],
      obj: [],
    };
  },
  computed: {
    filteredOperators() {
      if (this.queueSelect != '*') {
        return this.operators.filter(el => {
          return el.queues.some(queue => {
            return queue.name.includes(this.queueSelect);
          });
        });
      } else {
        return this.operators;
      }
    }
  },
  methods: {
    totalWait(data) {
      this.wait = data;
    },
    setupSocketConnection() {
      const parsedTelefone = (process.env.MIX_TELEFONE === 'true');
      if (parsedTelefone) {
        this.connection = io(`${location.protocol}//${location.hostname}:3007/realtimeModule`, {
          query: {
            source: "PizzaTotalActive",
            exten: user.getExtension()
          },
          reconnection: true,
          reconnectionAttempts: Infinity,
          reconnectionDelay: 1000,
          reconnectionDelayMax: 5000,
          randomizationFactor: 0.5,
          pingTimeout: 300000, // 5 minutos
          pingInterval: 60000  // 1 minuto
        });

        this.connection.on('connect', () => {
          console.info('Conectado ao serviço do realtime Dashboard');
        });

        this.connection.on('disconnect', (reason) => {
          console.info(`Desconectado: ${reason}`);
        });

        this.connection.on('reconnect_attempt', (attemptNumber) => {
          console.info(`Tentativa de reconexão #${attemptNumber}`);
        });
      } else {
        this.connection = {
          on: function () { },
          emit: function () { }
        };
      }
    },
    fetchRealtimeData() {
      axios.get('/reports/abandonRealtimeDashboard')
        .then(response => {
          const data = response.data;

          let totalAbandon = 0;
          let totalCompleted = 0;

          data.forEach(item => {
            totalAbandon += item.abandons + item.exitwithtimeout;
            totalCompleted += item.completedAgent + item.completedCaller;
          });

          this.abandon = totalAbandon;
          this.completed = totalCompleted;

        })
        .catch(error => {
          console.error('Error fetching realtime data:', error);
        });
    },
  },
  created() {
    axios.get('/realtime/listUsersPhone').then(({ data }) => {
      this.operators = data;
    });
    this.userStatus = 'Deslogado';

    this.active = getStatus().ligacao;
    this.setupSocketConnection();
    this.fetchRealtimeData();
    axios.get('/user-queues-total').then(({ data }) => {
      if (data.length > 0) {
        this.userQueues = data;
      }
    });
  },
  mounted() {
    this.interval = setInterval(() => {
      this.fetchRealtimeData();
      this.active = getStatus().ligacao;
    }, 1000);

  },
  beforeDestroy() {
    clearInterval(this.interval);
  }
};
</script>

<style scoped>
.container {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  margin-top: 40px;
}

.row {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}

.col {
  flex: 1;
  max-width: 35%;
  padding: 10px;
}

.card {
  border-radius: 6px;
  color: white;
  height: 30em;
  text-align: center;
  padding: 5em;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  transition: all 0.3s cubic-bezier(.25, .8, .25, 1);
}

.green {
  background-color: #16a085;
}

.orange {
  background-color: #f39c12;
}

.blue {
  background-color: #17a2b8;
}

.red {
  background-color: #c0392b;
}

.card-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.icon img {
  margin-bottom: 5px;
  width: 50px;
  height: 50px;
}

.details h3 {
  margin-top: 5px;
  font-size: 1.5em;
}

.details h1 {
  margin-top: 5px;
  font-size: 3em;
}

.details p {
  margin-top: 5px;
  color: black;
}
</style>
